<template>
  <div>
    <template v-if="isPhone">
      <mobile />
    </template>
    <template v-else>
      <computer />
    </template>
  </div>
</template>

<script>
import $utils from '../../utils/utils.js'
import Mobile from './components/mobile.vue'
import Computer from './components/computer.vue'
export default {
  components: {
    Mobile,
    Computer
  },
  data() {
    return {
      isPhone: $utils.isMobile()
    }
  },
}
</script>

<style lang='scss'>
.p-code-image{
  cursor: pointer;
}
body, button, input, select, textarea {
  outline: 0px;
  font: 400 12px / 1 "Microsoft YaHei", 微软雅黑, Arial;
}

</style>
